import { useEffect, useState, type FormEvent } from 'react';
import { post } from '../lib/api';
import { useStore, type User } from '../store';
import { CardCarousel } from '../components/CardCarousel';

/** Admins get past the pre-launch gate (the server enforces it too); everyone else sees this. */
export const isAdminUser = (u: User | null) => !!u && ['admin', 'super_admin'].includes(u.staff?.role ?? u.role);

/** Pre-launch page for the production site (COMING_SOON on the server). Only admins can sign in past it. */
export function ComingSoon() {
  const { user, cat, setUser, logout } = useStore();
  const [staff, setStaff] = useState(false);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  // a player who was already signed in (or signs in) isn't let in yet: sign them out, kindly
  useEffect(() => {
    if (user && !isAdminUser(user)) { setMsg(`Thanks ${user.display_name}! Gooflord isn't open yet. We'll let you know when it is.`); void logout(); }
  }, [user, logout]);
  const submit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault(); setErr(''); setBusy(true);
    const o = Object.fromEntries(new FormData(e.currentTarget).entries()) as Record<string, string>;
    try { const r = await post<{ user: User }>('/api/auth/login', { username: o.username, password: o.password }); setUser(r.user); }
    catch (ex) { setErr((ex as Error).message); } finally { setBusy(false); }
  };
  return (
    <div className="landing"><div className="hero coming-soon">
      <div className="intro">
        <img className="logo-img" src="/logo.png" alt="Gooflord" />
        <h1>Coming soon</h1>
        <p className="lede">Tame wild fighters, raid your mates, and be the first to drag your Gooflord to level 10. Ben's card game is almost ready for your phone, with your real cards.</p>
        {msg && <p className="note">{msg}</p>}
        {!staff ? <button type="button" className="btn xs ghost" onClick={() => setStaff(true)}>Staff sign in</button>
          : <form className="panel auth" onSubmit={submit} style={{ maxWidth: 360 }}>
            <div className="field"><label htmlFor="cs-user">Username or email</label><input id="cs-user" name="username" required autoComplete="username" /></div>
            <div className="field"><label htmlFor="cs-pass">Password</label><input id="cs-pass" name="password" type="password" required autoComplete="current-password" /></div>
            <div className="err" role="alert">{err}</div>
            <button className="btn primary block" disabled={busy}>{busy ? <span className="spin" /> : 'Sign in'}</button>
            <p className="muted small">Only admins can get in before launch.</p>
          </form>}
      </div>
      <CardCarousel cat={cat} />
    </div></div>
  );
}
